module.exports = __webpack_public_path__ + "static/contentful-82e41db438dea4d75ca878a464badb58.svg";